<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="toolbar" :inline="true" size="mini">
      <el-form-item label="关键字">
        <el-input v-model="params.keyword" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="params.d1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="params.d2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-button type="primary" @click="listSearch" size="mini">查询</el-button>
      <el-button type="success" @click="addCompany" size="mini">新增</el-button>
    </el-form>
    <paging :url="url.list" :params="params" ref="paging" style="width: 990px;">
      <el-table border slot-scope="grid" :data="grid.data" style="width: 100%;" height="500px" v-loading="grid.loading || loading">
        <el-table-column align="center" prop="F_CanNo" label="挂车号" width="100">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,false)" type="text" size="small">{{scope.row.F_CanNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="F_AllowMaxWeight" label="额定核载量" width="120"></el-table-column>
        <el-table-column align="center" prop="F_CurbWeight" label="整备质量" width="100"></el-table-column>
        <el-table-column align="center" prop="F_DrivingLicenseValidateDate" label="行驶证有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_RoadTransCode" label="道路运输证号" width="120"></el-table-column>
        <el-table-column align="center" prop="F_RoadTransValidateDate" label="道路运输证有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_ValidateDate" label="罐检报告有效期" width="160"></el-table-column>
        <el-table-column align="center" prop="F_AllowProduct" label="装载介质" width="120"></el-table-column>
        <el-table-column align="center" prop="F_MaxVolume" label="罐体容积(m³)" width="120"></el-table-column>
        <el-table-column align="center" prop="F_LPGLicenseCode" label="液化气罐车使用证编号" width="150"></el-table-column>
        <el-table-column align="center" prop="F_SurveyReportCode" label="定期检验报告编号" width="150"></el-table-column>
        <el-table-column align="center" prop="F_MaxPressure" label="最大工作压力" width="120"></el-table-column>
        <el-table-column align="center" prop="F_ReplaceVerifyDate" label="置换合格证明有效期" width="160"></el-table-column>
        <el-table-column fixed="right" label="操作" width="220" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row,true)" type="text" size="small">编辑</el-button>
            <el-button @click="onDelete(scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="onPhone(scope.row)" type="text" size="small">关联手机号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </paging>

    <!--修改弹框-->
    <dialog-form title="挂车"
                 :formTemplate="formTemplate"
                 :visible.sync="visible"
                 :form="form" :rules="rules"
                 :url="url.save"
                 :isEdit="isEdit"
                 :canEdit="canEdit"
                 :labelPosition="labelPosition"
                 :labelWidth="labelWidth"
                 @beforeSave="beforeSave"
                 @saved="editSave()">
    </dialog-form>

    <el-dialog :close-on-click-modal="false" center title="关联手机号" :visible.sync="dialogTablePhone">
      <el-button @click="" type="text" size="small"></el-button>
      <el-table :data="Phones" border>
        <el-table-column header-align="center" align="center" property="F_TelNo" label="手机号"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_CreateTime" label="创建时间"></el-table-column>
        <el-table-column header-align="center" align="center" property="F_Creator" label="操作人"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="onDeletePhone(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addPhone">新增关联手机号</el-button>
        <el-button type="primary" @click="dialogTablePhone = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
  import Paging from '@/components/Table/Paging'
  import DialogForm from '@/components/Dialogs/DialogForm';

  export default {
    components: {
      Paging, DialogForm
    },
    props: {
      screen: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      let validateCarNo = (rule, value, callback) => {
        let regex = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领台A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$)/;
        if (value != null && !regex.test(value)) {
          callback(new Error('请输入正确的车牌号'));
        } else {
          callback();
        }
      }
      return {
        labelWidth:'160px',
        labelPosition:'right',
        url: {
          list: SZH.assets.api + '/WHPTruckCan/GetGridJson',
          save: SZH.assets.api + '/WHPTruckCan/SumbitForm',
          delete: SZH.assets.api + '/WHPTruckCan/DeleteForm',
          get: SZH.assets.api + '/WHPTruckCan/GetFormJson',
          GetGridJsonLinkUser: SZH.assets.api + '/WHPDriver/GetGridJsonLinkUser',
          InsertLinkTelUser: SZH.assets.api + '/WHPDriver/InsertLinkTelUser',
          DeleteLinkTelUser: SZH.assets.api + '/WHPDriver/DeleteLinkTelUser',
          GetOILSort: SZH.assets.api + '/WHPTruckCan/GetOILSort',
        },
        loading: false,
        fullscreenLoading: false,
        params: {
          keyword:'',
          d1:'',
          d2:''
        },
        visible: false,
        form: {
          F_Id: '',
          F_CanNo: '',
          F_AllowMaxWeight: '',//额定核载量
          F_CurbWeight: '',//整备质量
          F_DrivingLicenseValidateDate: '',//行驶证有效期
          F_RoadTransCode: '',//道路运输证号
          F_RoadTransValidateDate: '',//道路运输证有效期
          F_ValidateDate: '',//罐检报告有效期
          F_AllowProduct: '',//装载介质
          F_MaxVolume: '',//罐体容积(m³)
          F_LPGLicenseCode: '',//液化气罐车使用证编号
          F_SurveyReportCode:'',//定期检验报告编号
          F_MaxPressure:'',//最大工作压力
          F_ReplaceVerifyDate:'',//置换合格证明有效期
          F_RoadTransImgUrl:'',//车辆道路运输证照片正面
          F_RoadTransImgUrl2:'',//车辆道路运输证照片反面
          F_SurveyReportImgUrl:'',//罐检报告照片正面
          F_SurveyReportImgUrl2:'',//罐检报告照片反面
          F_DriveringImgUrl1:'',//行驶证正面
          F_DriveringImgUrl2:'',//行驶证反面
          F_SpecialEquipmentImgUrl:'',//特种设备使用登记证
          F_RoadTransImgUrlBefore:[],
          F_RoadTransImgUrl2Before:[],
          F_SurveyReportImgUrlBefore:[],
          F_SurveyReportImgUrl2Before:[],
          F_DriveringImgUrl1Before:[],
          F_DriveringImgUrl2Before:[],
          F_SpecialEquipmentImgUrlBefore:[],
          F_RoadTransImgBase64On:'',
          F_RoadTransImgBase64Off:'',
          F_SurveyReportImgBase64On:'',
          F_SurveyReportImgBase64Off:'',
          F_DriveringImgBase64On:'',
          F_DriveringImgBase64Off:'',
          F_SpecialEquipmentImgBase64:'',
          IsOil:''
        },
        isEdit:false,
        formTemplate: [
          {col: 12, label: '挂车号', prop: 'F_CanNo'},
          {col: 12, label: '额定核载量', prop: 'F_AllowMaxWeight',type:'number'},
          {col: 12, label: '整备质量', prop: 'F_CurbWeight',type:'number'},
          {col: 12, label: '行驶证有效期', prop: 'F_DrivingLicenseValidateDate',type: "date"},
          {col: 12, label: '道路运输证号', prop: 'F_RoadTransCode'},
          {col: 12, label: '道路运输证有效期', prop: 'F_RoadTransValidateDate',type: "date"},
          {col: 12, label: '罐检报告有效期', prop: 'F_ValidateDate',type: "date"},
          {
            col: 12,label: "是否液化气",prop: "IsOil",type: "radio",
            options: [
              {label: "是",value: '1'},
              {label: "否",value: '0'},
            ],
            default: null,change: (v) => {
              this.changeType1(v)
            },
          },
          {col: 12, label: '装载介质', prop: 'F_AllowProduct',type: "select",options: [],filterable: true,default: null,change: (v) => {},},
          {col: 12, label: '罐体容积(m³)', prop: 'F_MaxVolume'},
          {col: 12, label: '液化气罐车使用证编号', prop: 'F_LPGLicenseCode',showByProp: [{prop: 'IsOil', value: '1'}]},
          {col: 12, label: '定期检验报告编号', prop: 'F_SurveyReportCode',showByProp: [{prop: 'IsOil', value: '1'}]},
          {col: 12, label: '最大工作压力', prop: 'F_MaxPressure',showByProp: [{prop: 'IsOil', value: '1'}]},
          {col: 12, label: '置换合格证明有效期', prop: 'F_ReplaceVerifyDate',type: "date",showByProp: [{prop: 'IsOil', value: '1'}]},
          {col: 12, label: '道路运输证照片正面', prop: 'F_RoadTransImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '道路运输证照片反面', prop: 'F_RoadTransImgUrl2Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '罐检报告照片正面', prop: 'F_SurveyReportImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '罐检报告照片反面', prop: 'F_SurveyReportImgUrl2Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '行驶证正面', prop: 'F_DriveringImgUrl1Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 12, label: '行驶证反面', prop: 'F_DriveringImgUrl2Before',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
          {col: 24, label: '特种设备使用登记证', prop: 'F_SpecialEquipmentImgUrlBefore',type: "pictureBase",default: [],formIdProp: "Id",pictureType: "WHPimg",limit: 1,},
        ],
        rules: {
          F_CanNo: [
            {required: true, message: '请输入挂车号', trigger: 'blur'},
          ],
          F_AllowMaxWeight: [
            {required: true, message: '请输入额定核载量', trigger: 'blur'},
          ],
          F_CurbWeight: [
            {required: true, message: '请输入整备质量', trigger: 'change'},
          ],
          F_DrivingLicenseValidateDate: [
            {required: true, message: '请选择行驶证有效期', trigger: 'change'},
          ],
          F_RoadTransCode: [
            {required: true, message: '请输入道路运输证号', trigger: 'change'},
          ],
          F_RoadTransValidateDate: [
            {required: true, message: '请选择道路运输证有效期', trigger: 'change'},
          ],
          F_ValidateDate: [
            {required: true, message: '请选择罐检报告有效期', trigger: 'change'},
          ],
          IsOil: [
            {required: true, message: '请选择是否液化气', trigger: 'change'},
          ],
          F_ReplaceVerifyDate: [
            {required: true, message: '请选择装载介质', trigger: 'change'},
          ],
          F_MaxVolume: [
            {required: true, message: '请输入罐体容积(m³)', trigger: 'blur'},
          ],
          F_LPGLicenseCode: [
            {required: true, message: '请输入液化气罐车使用证编号', trigger: 'blur'},
          ],
          F_SurveyReportCode: [
            {required: true, message: '请输入定期检验报告编号', trigger: 'blur'},
          ],
          F_MaxPressure: [
            {required: true, message: '请输入最大工作压力', trigger: 'blur'},
          ],
          F_AllowProduct: [
            {required: true, message: '请选择置换合格证明有效期', trigger: 'change'},
          ],

          F_RoadTransImgUrlBefore: [
            {required: true, message: '请选择道路运输证照片正面', trigger: 'blur'},
          ],
          F_RoadTransImgUrl2Before: [
            {required: true, message: '请选择道路运输证照片反面', trigger: 'blur'},
          ],
          F_SurveyReportImgUrlBefore: [
            {required: true, message: '请选择罐检报告照片正面', trigger: 'blur'},
          ],
          F_SurveyReportImgUrl2Before: [
            {required: true, message: '请选择罐检报告照片反面', trigger: 'blur'},
          ],
          F_DriveringImgUrl1Before: [
            {required: true, message: '请选择行驶证正面', trigger: 'blur'},
          ],
          F_DriveringImgUrl2Before: [
            {required: true, message: '请选择行驶证反面', trigger: 'blur'},
          ],
          F_SpecialEquipmentImgUrlBefore: [
            {required: true, message: '请选择特种设备使用登记证照片', trigger: 'blur'},
          ],
        },
        canEdit:false,
        dialogTablePhone:false,
        Phones:[],
        row:'',
        products:[],
        testU:true
      }
    },
    methods: {
      changeType1(v){
        let self = this;
        self.form.F_AllowProduct = null;
        self.changeType(v);
      },
      changeType(v){
        let self = this;
        // self.form.F_AllowProduct = null;
        if(v == '1'){
          for(var i in self.formTemplate){
            if(self.formTemplate[i].prop == 'F_AllowProduct'){
              self.formTemplate[i].options =  self.products.filter(item=>item.Attributes == 1);
            }
          }
        }else{
          for(var i in self.formTemplate){
            if(self.formTemplate[i].prop == 'F_AllowProduct'){
              self.formTemplate[i].options =  self.products.filter(item=>item.Attributes != 1);
            }
          }
        }
      },
      onPhone(row){
        let self = this;
        self.dialogTablePhone = true;
        self.getPhones(row);
      },
      getPhones(row){
        let self = this;
        self.row = row;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetGridJsonLinkUser, {
          Data:{
            keyValue: row.F_Id
          },
          PageIndex:1,
          PageSize:200
        }).then(result => {
          if (result.state == true) {
            self.Phones = result.data.Data
          } else {
            self.Phones = [];
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      addPhone(){
        let self = this;
        self.$prompt('请输入手机号', '新增手机号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^((13|14|15|17|18|19|16|11|12)[0-9]{9})?$/,
          inputErrorMessage: '手机号格式不正确',
          closeOnClickModal:false,
          center: true
        }).then(({ value }) => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.InsertLinkTelUser, {
            F_TelNo:value,
            F_Type:4,
            F_ObjectId:self.row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('操作成功');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {

        });
      },
      onDeletePhone(row){
        var self = this;
        self.$confirm(`将手机号${row.F_TelNo}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.DeleteLinkTelUser, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$message.success('删除成功!');
              self.getPhones(self.row);
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      addCompany(){
        let self = this;
        self.visible = true;
        self.canEdit = true;
        self.form.F_RoadTransImgUrlBefore = [];
        self.form.F_RoadTransImgUrl2Before = [];
        self.form.F_SurveyReportImgUrlBefore = [];
        self.form.F_SurveyReportImgUrl2Before = [];
        self.form.F_DriveringImgUrl1Before = [];
        self.form.F_DriveringImgUrl2Before = [];
        self.form.F_SpecialEquipmentImgUrlBefore = [];
      },
      listSearch() {
        this.$refs['paging'].reload();
      },
      beforeSave(){
        let self = this;
        self.form.F_RoadTransImgUrl = self.form.F_RoadTransImgUrlBefore[0].path;
        self.form.F_RoadTransImgUrl2 = self.form.F_RoadTransImgUrl2Before[0].path;
        self.form.F_SurveyReportImgUrl = self.form.F_SurveyReportImgUrlBefore[0].path;
        self.form.F_SurveyReportImgUrl2 = self.form.F_SurveyReportImgUrl2Before[0].path;
        self.form.F_DriveringImgUrl1 = self.form.F_DriveringImgUrl1Before[0].path;
        self.form.F_DriveringImgUrl2 = self.form.F_DriveringImgUrl2Before[0].path;
        self.form.F_SpecialEquipmentImgUrl = self.form.F_SpecialEquipmentImgUrlBefore[0].path;
      },
      // 保存
      editSave() {
        this.$message.success('保存成功');
        this.$refs['paging'].reload();
      },
      onEdit(row,flag){
        let self = this;

        const loading = self.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        self.visible = true;
        self.form.F_RoadTransImgUrlBefore = [];
        self.form.F_RoadTransImgUrl2Before = [];
        self.form.F_SurveyReportImgUrlBefore = [];
        self.form.F_SurveyReportImgUrl2Before = [];
        self.form.F_DriveringImgUrl1Before = [];
        self.form.F_DriveringImgUrl2Before = [];
        self.form.F_SpecialEquipmentImgUrlBefore = [];
        self.canEdit = flag;
        self.$http.post(self.url.get, {
          keyValue: row.F_Id
        }).then(result => {
          if (result.state == true) {
            self.$nextTick(()=>{
              for(let i in self.form){
                for(let k in result.data){
                  if(i == k){
                    self.form[i] = result.data[k];
                  }
                  if(i == 'F_AllowProduct'){
                    self.backPro(result.data['F_AllowProduct']);
                  }
                }
                if(i == 'F_RoadTransImgBase64On'){
                  let obj = {
                    path:result.data.F_RoadTransImgUrl,
                    Url:result.data.F_RoadTransImgBase64On
                  };
                  self.form.F_RoadTransImgUrlBefore.push(obj);
                }
                if(i == 'F_RoadTransImgBase64Off'){
                  let obj = {
                    path:result.data.F_RoadTransImgUrl2,
                    Url:result.data.F_RoadTransImgBase64Off
                  };
                  self.form.F_RoadTransImgUrl2Before.push(obj);
                }
                if(i == 'F_SurveyReportImgBase64On'){
                  let obj = {
                    path:result.data.F_SurveyReportImgUrl,
                    Url:result.data.F_SurveyReportImgBase64On
                  };
                  self.form.F_SurveyReportImgUrlBefore.push(obj);
                }
                if(i == 'F_SurveyReportImgBase64Off'){
                  let obj = {
                    path:result.data.F_SurveyReportImgUrl2,
                    Url:result.data.F_SurveyReportImgBase64Off
                  };
                  self.form.F_SurveyReportImgUrl2Before.push(obj);
                }
                if(i == 'F_DriveringImgBase64On'){
                  let obj = {
                    path:result.data.F_DriveringImgUrl1,
                    Url:result.data.F_DriveringImgBase64On
                  };
                  self.form.F_DriveringImgUrl1Before.push(obj);
                }
                if(i == 'F_DriveringImgBase64Off'){
                  let obj = {
                    path:result.data.F_DriveringImgUrl2,
                    Url:result.data.F_DriveringImgBase64Off
                  };
                  self.form.F_DriveringImgUrl2Before.push(obj);
                }
                if(i == 'F_SpecialEquipmentImgBase64'){
                  let obj = {
                    path:result.data.F_SpecialEquipmentImgUrl,
                    Url:result.data.F_SpecialEquipmentImgBase64
                  };
                  self.form.F_SpecialEquipmentImgUrlBefore.push(obj);
                }
              }
            });
          } else {

          }
          loading.close();
        }, () => {
          loading.close();
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
      backPro(v){
        let self = this;
        let arr = [];
        arr = self.products.filter(item=>item.value == v);
        self.form.IsOil = arr[0].Attributes;
        self.changeType(self.form.IsOil);
      },
      onDelete(row) {
        var self = this;
        self.$confirm(`将${row.F_CanNo}删除, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          self.fullscreenLoading = true;
          self.$http.post(self.url.delete, {
            keyValue: row.F_Id
          }).then(result => {
            if (result.state == true) {
              self.$refs['paging'].loadData();
            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            self.$message.error('数据作废失败，请检查您的网络是否可用。');
          });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      GetOILSortFun() {
        var self = this;
        self.$http.post(self.url.GetOILSort, {

        }).then(result => {
          if (result.state == true) {
            self.products = JSON.parse(result.data);
            // for(var i in self.formTemplate){
            //   if(self.formTemplate[i].prop == 'F_AllowProduct'){
            //     self.formTemplate[i].options =  self.products;
            //   }
            // }
          } else {
            self.products = [];
            // for(var i in self.formTemplate){
            //   if(self.formTemplate[i].prop == 'F_AllowProduct'){
            //     self.formTemplate[i].options =  self.products;
            //   }
            // }
          }
        }, () => {
          self.$message.error('数据作废失败，请检查您的网络是否可用。');
        });
      },
    },
    computed: {},
    created() {
    },
    mounted() {
      this.GetOILSortFun();
    },
    watch: {}

  }
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/HazardousChemicalsEntry/Trailer/Trailer.vue